module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/448.e82dd2f6.png";